import React, { useMemo } from "react";
import { useGrades } from "../contexts/GradesContext";

export default function GroupNine({ onExport }) {
  const { grades, coreData } = useGrades();
  const {
    diplomaAwarded,
    fails,
    slots,
    totalPoints,
  } = useMemo(() => {
    const activeSlots = ["1", "2", "3", "4", "5", "6"]
      .map((g) => {
        const d = grades[g];
        return d && d.grade != null && d.subject && d.level
          ? { group: g, ...d }
          : null;
      })
      .filter(Boolean);

    const subjectPoints = activeSlots.reduce((sum, { grade }) => sum + grade, 0);
    const corePoints = coreData.corePoints != null ? coreData.corePoints : 0;
    const total = subjectPoints + corePoints;

    const newFails = [];
    if (activeSlots.length !== 6)
      newFails.push("Not all 6 subjects have been entered");
    if (total < 24)
      newFails.push("Total points below 24");
    if (coreData.tokGrade === "E")
      newFails.push("Grade E in Theory of Knowledge");
    if (coreData.eeGrade === "E")
      newFails.push("Grade E in the Extended Essay");

    const hl = activeSlots.filter((s) => s.level === "HL");
    if (hl.length < 3 || hl.length > 4)
      newFails.push(`${hl.length} HL subject${hl.length === 1 ? "" : "s"} selected — need 3 or 4`);
    if (activeSlots.some((s) => s.grade === 1))
      newFails.push("Grade 1 in at least one subject");

    const twos = activeSlots.filter((s) => s.grade === 2).length;
    if (twos > 2) newFails.push(`${twos} grade 2s — maximum is 2`);

    const threes = activeSlots.filter((s) => s.grade === 3).length;
    if (threes > 3) newFails.push(`${threes} grade 3s — maximum is 3`);

    const hlSum = hl.reduce((sum, s) => sum + s.grade, 0);
    if (hl.length >= 3 && hlSum < 12)
      newFails.push(`Sum of HL grades is ${hlSum} — minimum is 12`);

    const sl = activeSlots.filter((s) => s.level === "SL");
    const slSum = sl.reduce((sum, s) => sum + s.grade, 0);
    if (sl.length === 3 && slSum < 9)
      newFails.push(`Sum of SL grades is ${slSum} — minimum is 9`);
    if (sl.length === 2 && slSum < 5)
      newFails.push(`Sum of SL grades is ${slSum} — minimum is 5`);

    return {
      diplomaAwarded: newFails.length === 0,
      fails: newFails,
      slots: activeSlots,
      totalPoints: total,
    };
  }, [grades, coreData]);




  const complete = slots.length === 6 && coreData.corePoints != null;
  const displayTotal = slots.length || coreData.corePoints != null ? totalPoints : "--";
  const subjectPoints = slots.reduce((sum, slot) => sum + slot.grade, 0);
  return (
    <section className="diploma-section" aria-labelledby="diploma-title">
      <div><h2 id="diploma-title">Your diploma total.</h2>
        <p id="diploma-status">{!complete ? "Complete your marks to check the diploma requirements." : diplomaAwarded ? "These marks meet the checked diploma requirements. Your school confirms the final result and remaining diploma requirements." : "These marks do not meet all the checked diploma requirements."}</p>
        <ul id="requirements">{complete && fails.map(reason => <li key={reason}>{reason}</li>)}</ul>
        <button id="download" className="ib-action" disabled={!slots.length && coreData.corePoints == null} onClick={onExport}>Download your results <span aria-hidden="true">&#8595;</span></button>
      </div>
      <div className="diploma-number"><div className="total-bubble"><output id="final-total">{displayTotal}</output><span>/ 45</span></div><p id="points-breakdown">{displayTotal === "--" ? "42 subject points + up to 3 core points" : subjectPoints + " subject points + " + (coreData.corePoints ?? "?") + " core points" + (complete ? "" : " (so far)")}</p></div>
    </section>
  );
}
